import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import mysqlIcon from "../assets/mysql-icon.svg";
import nodeIcon from "../assets/node-icon.svg";
import reactIcon from "../assets/react-icon.svg";
import vueIcon from "../assets/vue-icon.svg";
import mongoDB from "../assets/mongodb.png";
import php from "../assets/php.png";
import github from "../assets/github-icon.svg";
import laravel from "../assets/laravel.png";
import mySql from "../assets/mysql.png";

const Parts = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: "none",
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          lineLinked: {
            blink: false,
            color: "#000",
            consent: false,
            distance: 150,
            enable: false,
            opacity: 0.4,
            width: 1,
          },
          move: {
            attract: {
              enable: false,
              rotate: {
                x: 600,
                y: 1200,
              },
            },
            bounce: false,
            direction: "none",
            enable: true,
            outMode: "out",
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            limit: 20,
            value: 15,
          },
          opacity: {
            animation: {
              enable: true,
              minimumValue: 0.2,
              speed: 1,
              sync: false,
            },
            random: true,
            value: 1,
          },
          rotate: {
            animation: {
              enable: true,
              speed: 5,
              sync: false,
            },
            direction: "random",
            random: true,
            value: 0,
          },
          shape: {
            character: {
              fill: false,
              font: "Verdana",
              style: "",
              value: "*",
              weight: "400",
            },
            image: [
              {
                src: laravel,
                width: 20,
                height: 20,
              },
              {
                src: mongoDB,
                width: 20,
                height: 40,
              },
              {
                src: mySql,
                width: 20,
                height: 20,
              },
              {
                src: php,
                width: 20,
                height: 20,
              },
              {
                src: github,
                width: 20,
                height: 20,
              },
              {
                src: mysqlIcon,
                width: 20,
                height: 20,
              },
              {
                src: nodeIcon,
                width: 20,
                height: 20,
              },
              {
                src: reactIcon,
                width: 20,
                height: 20,
              },
              {
                src: vueIcon,
                width: 20,
                height: 20,
              },
            ],
            polygon: {
              sides: 5,
            },
            stroke: {
              color: "#000000",
              width: 0,
            },
            type: "image",
          },
          size: {
            animation: {
              enable: false,
              minimumValue: 0.1,
              speed: 40,
              sync: false,
            },
            random: false,
            value: 16,
          },
        },
        // particles: {
        //   color: {
        //     value: "#ffffff",
        //   },
        //   links: {
        //     color: "#ffffff",
        //     distance: 150,
        //     enable: true,
        //     opacity: 0.5,
        //     width: 1,
        //   },
        //   collisions: {
        //     enable: true,
        //   },
        //   move: {
        //     directions: "none",
        //     enable: true,
        //     outModes: {
        //       default: "bounce",
        //     },
        //     random: false,
        //     speed: 6,
        //     straight: false,
        //   },
        //   number: {
        //     density: {
        //       enable: true,
        //       area: 800,
        //     },
        //     value: 80,
        //   },
        //   opacity: {
        //     value: 0.5,
        //   },
        //   shape: {
        //     type: "circle",
        //   },
        //   size: {
        //     value: { min: 1, max: 5 },
        //   },
        // },
        detectRetina: true,
      }}
    />
  );
};
export default Parts;
